// Let's define events here so we
// can easily track them in the codebase
export const TrackEventName = {
  ACCEPT_LOAN_OFFER_CLICKED: 'accept_loan_offer_clicked',
  ADD_CONTACT_MODAL_ADD_NEW_CONTACT_CLICKED:
    'add_contact_modal_add_new_contact_clicked',
  ADD_TRADE_SUPPORTING_DOCUMENTS_CLICKED: 'supporting_document_add_clicked',
  APPLY_FOR_A_LOAN_NOW_CLICKED: 'apply_for_a_loan_now_clicked',
  APPLY_FOR_CREDIT_LIMIT_INCREASE_CLICKED:
    'apply_for_credit_limit_increase_clicked',
  BACK_CLICKED: 'back_clicked',
  BANK_ACCOUNT_BUSINESS_CLICKED: 'bank_account_business_clicked',
  BANK_ACCOUNT_PERSONAL_CLICKED: 'bank_account_personal_clicked',
  BIR_UPLOAD_SUBMIT_FORM_CLICKED: 'bir_upload_submit_form_clicked',
  BIRTH_DAY_FOCUSED: 'birth_day_focused',
  BIRTH_MONTH_FOCUSED: 'birth_month_focused',
  BIRTH_YEAR_FOCUSED: 'birth_year_focused',
  BUSINESS_INFO_SUBMIT_FORM_CLICKED: 'business_info_submit_form_clicked',
  CANCEL_CLICKED: 'cancel_clicked',
  CHECKBOX_FOUR_CLICKED: 'checkbox_4_clicked',
  CHECKBOX_ONE_CLICKED: 'checkbox_1_clicked',
  CHECKBOX_THREE_CLICKED: 'checkbox_3_clicked',
  CHECKBOX_TWO_CLICKED: 'checkbox_2_clicked',
  CIVIL_STATUS_FOCUSED: 'civil_status_focused',
  CLIENTS_GOVERNMENT_AGENCIES_CLICKED: 'clients_government_agencies_clicked',
  CLIENTS_SOLEPROP_CORP_CLICKED: 'clients_soleprop_corp_clicked',
  CLIENTS_INDIVIDUAL_CLICKED: 'clients_individual_clicked',
  COMPANY_TYPE_CLICKED: 'company_type_clicked',
  CLOSE_MODAL_CLICKED: 'close_modal_clicked',
  COMPLETE_PERSONAL_INFO_CLICKED: 'complete_personal_info_clicked',
  COMPLETE_BUSINESS_INFO_CLICKED: 'complete_business_info_clicked',
  COMPLETE_PROFILE_SUBMIT_CLICKED: 'complete_profile_submit_clicked',
  CONTACT_DROPDOWN_CLICKED: 'contact_dropdown_clicked',
  CONTACT_SUPPORT_CLICKED: 'contact_support_clicked',
  CONTINUE_CLICKED: 'continue_clicked',
  CREDIT_BOOST_DOC_VIEW_CLICKED: 'credit_boost_doc_view_clicked',
  CREDIT_LINE_BUTTON_CLICKED: 'credit_line_button_clicked',
  DOC_STATUS_CLICKED: 'document_status_dropdown_clicked',
  DOC_TYPE_CLICKED: 'document_type_dropdown_clicked',
  DOCS_BIR_CERT_CLICKED: 'docs_bir_cert_clicked',
  DOCS_SEC_CERT_CLICKED: 'docs_sec_cert_clicked',
  DOCS_DTI_CERT_CLICKED: 'docs_dti_cert_clicked',
  DOCS_CDA_REGISTRATION_CLICKED: 'docs_cda_registration_clicked',
  DOCS_NONE_CLICKED: 'docs_none_clicked',
  DOCUMENT_DESCRIPTION_CLICKED: 'document_description_clicked',
  EDIT_BILLING_ADDRESS_CLICKED: 'edit_billing_address_clicked',
  EMAIL_ADDRESS_FOCUSED: 'email_address_focused',
  FAQS_CLICKED: 'faqs_clicked',
  FIRST_NAME_FOCUSED: 'first_name_focused',
  FORGOT_PASSWORD_CLICKED: 'forgot_password_clicked',
  GENDER_FOCUSED: 'gender_focused',
  GET_STARTED_CLICKED: 'get_started_clicked',
  GO_BACK_TO_LOANS_LIST_CLICKED: 'go_back_to_loans_list_clicked',
  GO_BACK_TO_LOGIN_PAGE_CLICKED: 'go_back_to_login_page_clicked',
  INDUSTRY_CLICKED: 'industry_clicked',
  INVOICE_ADD_FILES_CLICKED: 'invoice_add_files_clicked',
  INVOICE_CUSTOMER_CONTACT_EDIT_CLICKED:
    'invoice_customer_contact_edit_clicked',
  INVOICE_CUSTOMER_CONTACT_ADD_CLICKED: 'invoice_customer_contact_add_clicked',
  INVOICE_CUSTOMER_CONTACT_DELETE_CLICKED:
    'invoice_customer_contact_delete_clicked',
  INVOICE_REPLACE_FILES_CLICKED: 'invoice_replace_files_clicked',
  ISSUING_BANK_CLICKED: 'issuing_bank_clicked',
  IS_PAGE_HELPFUL_NO_CLICKED: 'is_page_helpful_no_clicked',
  IS_PAGE_HELPFUL_OTHER_CLICKED: 'is_page_helpful_other_clicked',
  IS_PAGE_HELPFUL_YES_CLICKED: 'is_page_helpful_yes_clicked',
  LAST_NAME_FOCUSED: 'last_name_focused',
  LIST_OF_BANKS_MODAL_CLICKED: 'list_of_banks_modal_clicked',
  LOAN_OFFER_REPAYMENT_OPTION_CLICKED: 'loan_offer_repayment_option_clicked',
  LOAN_OFFER_BREAKDOWN_CLICKED: 'loan_offer_breakdown_clicked',
  LOAN_VIEW_DETAILS_CLICKED: 'loan_view_details_clicked',
  LOG_OUT_AND_CONTINUE_CLICKED: 'log_out_and_continue_clicked',
  LOGIN_CLICKED: 'log_in_clicked',
  LOGOUT_CLICKED: 'log_out_clicked',
  MODAL_CANCEL_CLICKED: 'modal_cancel_clicked',
  MODAL_SAVE_CLICKED: 'modal_save_clicked',
  MODAL_CLOSE_CLICKED: 'modal_close_clicked',
  NAVBAR_ACCOUNT_CHAT_CLICKED: 'nav_bar_account_chat_to_us_clicked',
  NAVBAR_ACCOUNT_CLICKED: 'nav_bar_account_clicked',
  NAVBAR_ACCOUNT_COMPANY_INFO_CLICKED: 'nav_bar_account_company_info_clicked',
  NAVBAR_ACCOUNT_FAQS_CLICKED: 'nav_bar_account_faqs_clicked',
  NAVBAR_ACCOUNT_LOGOUT_CLICKED: 'nav_bar_account_logout_clicked',
  NAVBAR_ACCOUNT_MY_ACCOUNT_CLICKED: 'nav_bar_account_my_account_clicked',
  NAVBAR_ACCOUNT_REQS_CLICKED: 'nav_bar_account_requirements_clicked',
  NAVBAR_ACCOUNT_ALERTS_MANAGER_CLICKED: 'nav_bar_account_alerts_manager_clicked',
  NAVBAR_APPLICATIONS_CLICKED: 'nav_bar_applications_clicked',
  NAVBAR_APPLY_CLICKED: 'nav_bar_apply_clicked',
  NAVBAR_APPLY_UPLOAD_INVOICE_CLICKED: 'nav_bar_apply_upload_invoice_clicked',
  NAVBAR_APPLY_UPLOAD_PO_CLICKED: 'nav_bar_apply_upload_purchase_order_clicked',
  NAVBAR_HOME_CLICKED: 'nav_bar_dashboard_clicked',
  NAVBAR_LOANS_CLICKED: 'nav_bar_loans_clicked',
  NAVBAR_BUSINESS_ACCOUNT_CLICKED: 'nav_bar_business_account_clicked',
  NOTIFICATIONS_BELL_CLICKED: 'notifications_bell_clicked',
  NUMBER_OF_EMPLOYEES_CLICKED: 'number_of_employees_clicked',
  PASSWORD_LINK_EXPIRED_CLICKED: 'password_link_expired_clicked',
  PURCHASE_ORDER_ADD_FILES_CLICKED: 'purchase_order_add_files_clicked',
  PURCHASE_ORDER_CUSTOMER_CONTACT_ADD_CLICKED:
    'purchase_order_customer_contact_add_clicked',
  PURCHASE_ORDER_CUSTOMER_CONTACT_DELETE_CLICKED:
    'purchase_order_customer_contact_delete_clicked',
  PURCHASE_ORDER_CUSTOMER_CONTACT_EDIT_CLICKED:
    'purchase_order_customer_contact_edit_clicked',
  PURCHASE_ORDER_REPLACE_FILES_CLICKED: 'purchase_order_replace_files_clicked',
  PROJECT_DETAILS_CLICKED: 'project_details_clicked',
  PROJECT_FILTER_APPLIED: 'project_filter_applied',
  PROJECT_FINDER_ALERT_MODAL_OPENED: 'project_finder_alert_modal_opened',
  PROJECT_FINDER_ALERT_CREATED: 'project_finder_alert_created',
  PROJECT_FILTER_DELETED: 'project_filter_deleted',
  REFER_CLICKED: 'refer_clicked',
  REFERRAL_BUTTON_CLICKED: 'referral_button_clicked',
  RECEIVE_ORDERS_NO_CLICKED: 'receive_orders_no_clicked',
  RECEIVE_ORDERS_YES_CLICKED: 'receive_orders_yes_clicked',
  REGION_SELECT_FOCUSED: 'region_select_focused',
  REGION_SUBMIT_CLICKED: 'region_submit_clicked',
  REGISTER_HERE_CLICKED: 'register_here_clicked',
  REMOVE_FILE_CLICKED: 'remove_file_clicked',
  REQUEST_NEW_PASSWORD_CLICKED: 'request_new_password_clicked',
  REQUEST_NEW_RESET_LINK_CLICKED: 'request_new_reset_link_clicked',
  RESEND_PASSWORD_LINK_CLICKED: 'resend_password_link_clicked',
  RESET_PASSWORD_CLICKED: 'reset_password_clicked',
  RESUBMIT_TRADE_DOCUMENT_CLICKED: 'resubmit_trade_document_clicked',
  REVIEW_LOAN_OFFER_CLICKED: 'review_loan_offer_clicked',
  ROLE_OWNER_FOCUSED: 'role_owner_focused',
  ROLE_BOARDMEMBER_FOCUSED: 'role_boardmember_focused',
  ROLE_EXECMANAGEMENT_FOCUSED: 'role_execmanagement_focused',
  ROLE_FINANCEMANAGER_FOCUSED: 'role_financemanager_focused',
  ROLE_TREASURY_FOCUSED: 'role_treasury_focused',
  ROLE_SECRETARY_ASST_FOCUSED: 'role_secretary_asst_focused',
  ROLE_EMPLOYEE_FOCUSED: 'role_employee_focused',
  SAVE_CHANGES_COMPANY_NAME_CLICKED: 'save_changes_company_name_clicked',
  SAVE_CHANGES_EMAIL_ADDRESS_CLICKED: 'save_changes_email_address_clicked',
  SAVE_CHANGES_NAME_CLICKED: 'save_changes_name_clicked',
  SEND_FEEDBACK_CLICKED: 'send_feedback_clicked',
  SUB_INDUSTRY_CLICKED: 'sub_industry_clicked',
  SUBMIT_FOR_VERIFICATION_ALL_CLICKED: 'submit_for_verification_all_clicked',
  SUBMIT_FOR_VERIFICATION_BUSINESS_CLICKED:
    'submit_for_verification_business_clicked',
  SUBMIT_FOR_VERIFICATION_PERSONAL_CLICKED:
    'submit_for_verification_personal_clicked',
  SUBMIT_FORM_CLICKED: 'submit_form_clicked',
  SUPPORTING_DOCUMENT_ADD_CLICKED: 'supporting_document_add_clicked',
  SUPPORTING_DOCUMENT_ADD_ANOTHER_CLICKED:
    'supporting_document_add_another_clicked',
  SUPPORTING_DOCUMENT_MODAL_CLOSE_CLICKED:
    'supporting_document_modal_close_clicked',
  SUPPORTING_DOCUMENT_MODAL_NO_CLICKED: 'supporting_document_modal_no_clicked',
  SUPPORTING_DOCUMENT_MODAL_YES_CLICKED:
    'supporting_document_modal_yes_clicked',
  SUPPORTING_DOCUMENT_REMOVE_CLICKED: 'supporting_document_remove_clicked',
  TERMS_OF_SERVICE_CLICKED: 'terms_of_service_clicked',
  TRADE_DOC_VIEW_DETAILS_CLICKED: 'trade_doc_view_details_clicked',
  UPDATE_CLICKED: 'update_clicked',
  UPLOAD_BIR_CLICKED: 'upload_bir_clicked',
  UPLOAD_DOCUMENTS_CLICKED: 'upload_documents_clicked',
  UPLOAD_DTI_CLICKED: 'upload_dti_clicked',
  UPLOAD_FILE_CLICKED: 'upload_file_clicked',
  UPLOAD_GIS_CLICKED: 'upload_gis_clicked',
  UPLOAD_PRIMARY_ID_CLICKED: 'upload_primary_id_clicked',
  UPLOAD_PROOF_OF_BILLING_CLICKED: 'upload_proof_of_billing_clicked',
  USE_NEW_ACCOUNT_CLICKED: 'use_new_account_clicked',
  USE_PREVIOUSLY_USED_ACCOUNT_CLICKED: 'use_previously_used_account_clicked',
  VIEW_REQUIREMENTS_LIST_CLICKED: 'view_requirements_list_clicked',
  ZENDESK_CLOSE_CLICKED: 'zendesk_close_clicked',
  ZENDESK_END_CHAT_CLICKED: 'zendesk_end_chat_clicked',
  ZENDESK_OPEN_CLICKED: 'zendesk_open_clicked',
  ZENDESK_START_CHAT_CLICKED: 'zendesk_start_chat_clicked',
};

export const PageViewName = {
  ADD_CONTACT_VIEWED: 'add_contact_viewed',
  ALERTS_MANAGER_VIEWED: 'alerts_manager_viewed',
  APPLICATIONS_VIEWED: 'applications_viewed',
  APPLY_FLOW_SUCCESS_VIEWED: 'apply_flow_success_viewed',
  APPLY_VIEWED: 'apply_flow_viewed',
  BIR_UPLOAD_VIEWED: 'onboarding_bir_upload_viewed',
  COMPANY_INFORMATION_VIEWED: 'company_information_viewed',
  COMPLETE_PROFILE_VIEWED: 'complete_profile_viewed',
  CREDIT_BOOST_SUMMARY_VIEWED: 'credit_boost_summary_viewed',
  CREDIT_BOOST_UPLOAD_VIEWED: 'credit_boost_upload_viewed',
  FORGOT_PASSWORD_VIEWED: 'forgot_password_viewed',
  FORGOT_PASSWORD_LANDING_PAGE_VIEWED: 'forgot_password_landing_page_viewed',
  INVOICE_UPLOAD_VIEWED: 'invoice_upload_viewed',
  PURCHASE_ORDER_UPLOAD_VIEWED: 'purchase_order_upload_viewed',
  HOME_SCREEN_VIEWED: 'home_screen_viewed',
  INVOICE_DETAILS_VIEWED: 'invoice_details_viewed',
  LOAN_OFFER_ACCEPTANCE_CHEQUE_VERIFYING_VIEWED:
    'loan_offer_acceptance_cheque_verifying_viewed',
  LOAN_OFFER_ACCEPTANCE_LOAN_AGREEMENT_VIEWED:
    'loan_offer_acceptance_loan_agreement_viewed',
  LOAN_OFFER_ACCEPTANCE_LOAN_TERM_VIEWED:
    'loan_offer_acceptance_loan_term_viewed',
  LOAN_OFFER_ACCEPTANCE_SUMMARY_VIEWED: 'loan_offer_acceptance_summary_viewed',
  LOAN_OFFER_ACCEPTANCE_UPLOAD_CHEQUE_VIEWED: 'loan_offer_acceptance_upload_cheque_viewed',
  LOAN_DETAILS_VIEWED: 'loan_details_viewed',
  LOANS_VIEWED: 'loans_viewed',
  LOGIN_VIEWED: 'login_viewed',
  MY_ACCOUNT_VIEWED: 'my_account_viewed',
  NOTIFICATIONS_VIEWED: 'notifications_viewed',
  ONBOARDING_BUSINESS_INFO_VIEWED: 'onboarding_business_info_viewed',
  ONBOARDING_GIS_VIEWED: 'onboarding_gis_viewed',
  ONBOARDING_OWNERSHIP_DOC_VIEWED: 'onboarding_ownership_doc_viewed',
  ONBOARDING_PERSONAL_INFO_VIEWED: 'onboarding_personal_info_viewed',
  ONBOARDING_PRIMARY_VALID_ID_VIEWED: 'onboarding_primary_valid_id_viewed',
  ONBOARDING_PROOF_OF_BILLING_VIEWED: 'onboarding_proof_of_billing_viewed',
  PASSWORD_LINK_EXPIRED_VIEWED: 'password_link_expired_viewed',
  PURCHASE_ORDER_DETAILS_VIEWED: 'purchase_order_details_viewed',
  PROJECT_FINDER_VIEWED: 'project_finder_viewed',
  REGION_SELECT_VIEWED: 'region_select_viewed',
  REQUIREMENTS_PAGE_VIEWED: 'requirements_page_viewed',
  RESET_PASSWORD_VIEWED: 'reset_password_viewed',
  TRADE_DOC_ADD_SUPPORTING_DOC_VIEWED: 'trade_doc_add_supporting_doc_viewed',
  USER_PROFILE_VIEWED: 'user_profile_viewed',
  WELCOME_VIEWED: 'welcome_viewed',
};

export const PageName = {
  ADD_CONTACT: 'add_contact',
  ADD_NEW_PASSWORD: 'add_new_password',
  APPLICATIONS: 'applications',
  APPLY_FLOW: 'apply_flow',
  APPLY_FLOW_SUCCESS: 'apply_flow_success',
  COMPANY_INFORMATION: 'company_information',
  CREDIT_BOOST_SUMMARY: 'credit_boost_summary',
  CREDIT_BOOST_UPLOAD: 'credit_boost_upload',
  FORGOT_PASSWORD: 'forgot_password',
  FORGOT_PASSWORD_LANDING_PAGE: 'forgot_password_landing_page',
  HOME_SCREEN: 'home_screen',
  INVOICE_UPLOAD_ONE: 'invoice_upload_1',
  LOGIN: 'login',
  ONBOARDING_PERSONAL_INFO: 'onboarding_personal_info',
  ONBOARDING_PROOF_OF_BILLING: 'onboarding_proof_of_billing',
  ONBOARDING_PRIMARY_VALID_ID: 'onboarding_primary_valid_id',
  ONBOARDING_BUSINESS_INFO: 'onboarding_business_info',
  ONBOARDING_OWNERSHIP_DOC: 'onboarding_ownership_doc',
  ONBOARDING_BIR: 'onboarding_bir',
  ONBOARDING_GIS: 'onboarding_gis',
  PASSWORD_LINK_EXPIRED: 'password_link_expired',
  PURCHASE_ORDER_UPLOAD_ONE: 'po_upload_1',
  PROJECT_FINDER: 'project_finder',
  REQUIREMENTS: 'requirements',
  REQUIREMENTS_ALL_COMPLETE: 'requirements_all_complete',
  LOANS: 'loans',
  LOAN_DETAILS: 'loan_details',
  LOAN_OFFER_ACCEPTANCE_SUMMARY: 'loan_offer_acceptance_summary',
  LOAN_OFFER_ACCEPTANCE_LOAN_TERMS: 'loan_offer_acceptance_loan_terms',
  LOAN_OFFER_ACCEPTANCE_LOAN_AGREEMENT: 'loan_offer_acceptance_loan_agreement',
  LOAN_OFFER_ACCEPTANCE_UPLOAD_CHEQUE: 'loan_offer_acceptance_upload_cheque',
  LOAN_OFFER_ACCEPTANCE_CHEQUE_VERIFYING:
    'loan_offer_acceptance_cheque_verifying',
  MY_ACCOUNT: 'my_account',
  NOTIFICATIONS: 'notifications',
  RESET_PASSWORD: 'reset_password',
  TRADE_DOC_ADD_CONTACT_MENU: 'trade_doc_add_contact_menu',
  TRADE_DOC_ADD_NEW_CONTACT_FORM: 'trade_doc_add_new_contact_form',
  TRADE_DOC_ADD_SUPPORTING_DOC: 'trade_doc_add_supporting_doc',
  TRADE_DOC_DETAILS: 'trade_doc_details',
  TRADE_DOC_FOR_RESUBMISSION: 'trade_doc_for_resubmission',
  WELCOME: 'welcome',
};



// WEBPACK FOOTER //
// ./src/features/shared/constants/SegmentEvents.js